import React, { Component } from 'react';
import { withRouterV6 as withRouter } from '../../../helpers/withRouterV6.jsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-redux-i18n';

import { Record } from '../../../modules/bin/utility';

import * as donationActions from '../../donation/store/donationActions';
import * as templateBuilderActions from '../../../modules/template-builder-ex';

import BasePage from '../../../components/common/basePageView';
import Spinner from '../../../components/common/spinner';
import { TemplateOptions } from '../../../components/template/templateOptions';
import RecordResultMessage from '../../../components/common/recordResult';
import TransferDonationTemplate from './template';
import { paths } from './constants/template';

class TransferDonation extends Component {
  constructor(props) {
    super(props);
    props.donationActions.getRecord(props.match.params.id);
  }

  onSave = (data) => {
    this.props.donationActions.createTransferDonation(data);
  };

  clearMessages = () => {
    this.props.donationActions.clearRecordMessages('transferDonationRecord');
  };

  goToDonationsList = () => {
    this.props.history.push(`/donations`);
  };

  initTemplateBuilderModel = () => {
    if (!this.props.isTemplateInited) {
      const donation = this.props.record.data.data;

      const model = new TemplateOptions()
        .setModel(donation)
        .setValue(paths.CUSTOMER_LAST_NAME, donation.donor.lastName)
        .setValue(paths.CUSTOMER_FIRST_NAME, donation.donor.firstName)
        .setValue(paths.CUSTOMER_EMAIL, donation.donor.email)
        .setValue(paths.CAMPAIGN_ID, '');

      model.disable(paths.TARGET_AMOUNT);
      model.disable(paths.CUSTOMER_FIRST_NAME);
      model.disable(paths.CUSTOMER_LAST_NAME);
      model.disable(paths.CUSTOMER_EMAIL);
      model.hide(paths.PAGE_ID);

      this.props.templateBuilderActions.setTemplateModel(model.get());
    }
  };

  render() {
    const isLoading =
      Record.notStarted(this.props.record) ||
      Record.isRecordLoading(this.props.record);
    const isSaving = Record.isRecordLoading(this.props.transferDonationRecord);
    const isSuccess = Record.isSuccess(this.props.transferDonationRecord);

    if (isLoading) {
      return <Spinner />;
    }

    if (isSuccess) {
      this.goToDonationsList();
    }

    this.initTemplateBuilderModel();

    return (
      <BasePage>
        <RecordResultMessage
          record={this.props.transferDonationRecord}
          onDismiss={this.clearMessages}
        />

        <h1>
          <Translate value="donation.transfer-donation.title" />
        </h1>

        <TransferDonationTemplate onSave={this.onSave} isLoading={isSaving} />
      </BasePage>
    );
  }
}

const mapState = ({ donation, templateBuilderEx }) => {
  return {
    record: donation.record,
    transferDonationRecord: donation.transferDonationRecord,
    isTemplateInited: templateBuilderEx.inited
  };
};

const mapDispatch = (dispatch) => {
  return {
    donationActions: bindActionCreators(donationActions, dispatch),
    templateBuilderActions: bindActionCreators(templateBuilderActions, dispatch)
  };
};

const TransferDonationContainer = withRouter(
  connect(mapState, mapDispatch)(TransferDonation)
);
export default TransferDonationContainer;
